<nz-alert *ngIf="!activeProject?.project_id"
	nzType="warning" nzShowIcon
	nzMessage="{{ 'message.warning.project.noneLoaded.title' | translate }}"
	nzDescription="{{ 'message.warning.project.noneLoaded.description' | translate }}"
></nz-alert>

<div *ngIf="activeProject?.project_id">
	<app-form-schema-renderer *ngIf="resolvedSchema && data"
		[property]="[]" [schema]="resolvedSchema" [data]="data" [readonly]="false"
		(emitFormSubmit)="createNewParticipant($event)" [formID]="participantFormID"
		(emitFormValid)="setSubmitActive($event)"
	>
	</app-form-schema-renderer>
	<div nz-row [nzJustify]="'space-between'">
		<div nz-col>
			<div nz-row [nzGutter]="[16, 6]">
				<div nz-col>
					<app-splitbutton [elements]="[userCancelSplitButton]"></app-splitbutton>
				</div>
			</div>
		</div>
		<div nz-col>
			<div nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]">
				<div nz-col>
					<app-splitbutton *ngIf="resolvedSchema && data"
									[elements]="[userAddSplitButton]"
					>
					</app-splitbutton>
				</div>
			</div>
		</div>
	</div>
</div>
